import { cn } from '@rocco/utils/cn';
import { useProfileFamily } from '@modules/professional/hook/use-profile-family';
import { DetailTileCard } from '~/ui-rocco/pages/detail-shared';
import {
    brandToTile,
    PROFESSIONAL_TILE_LOGO,
    PROFESSIONAL_TILE_MEDIA,
    PROFESSIONAL_TILE_SIZES,
    PROFESSIONAL_TILE_TEXT,
} from './professional-tile-props';

/**
 * The brand family as a tile grid (Figma 5522:96684) — every brand in the
 * family, this profile included, on the same tile the Network tab's connections
 * grid uses. Four across on desktop, two on mobile like every other grid on the
 * page. The Network tab keeps this grid; the overview accordion shows the same
 * brands as a carousel instead. Renders nothing without a family.
 */
export const ProfessionalBrandFamilyGrid = ({
    className,
}: {
    className?: string;
}) => {
    const family = useProfileFamily();
    if (!family) return null;

    return (
        <div
            className={cn(
                'grid grid-cols-2 gap-x-2 gap-y-8 md:grid-cols-4 md:gap-x-3 md:gap-y-[3rem]',
                className,
            )}
        >
            {family.brands.map((brand) => (
                <DetailTileCard
                    key={brand.id}
                    tile={brandToTile(brand)}
                    section="ProfessionalBrandFamily"
                    mediaClassName={PROFESSIONAL_TILE_MEDIA}
                    logoClassName={PROFESSIONAL_TILE_LOGO}
                    textClassName={PROFESSIONAL_TILE_TEXT}
                    sizes={PROFESSIONAL_TILE_SIZES}
                />
            ))}
        </div>
    );
};
